import { type FC } from 'react';
import {
  Globe
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconGlobeProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconGlobe: FC<UiIconGlobeProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Globe}
      {...props}
    />
  );
};
